<template lang="html">
  <main>
    <img src="../assets/logo_color.png" alt="logo" class="logo">
    <h1>
      Log In
    </h1>
    <v-form class="login-form" ref="form" v-model="valid" lazy-validation>
      <v-text-field
        class="form-input"
        ref="email"
        type="email"
        v-model="email"
        :rules="[v => !!v || 'Email is required']"
        label="Email"
        @keyup.enter="callLoginAction"
        required
        id="email"
      ></v-text-field>
      <v-text-field
        class="form-input"
        ref="password"
        type="password"
        v-model="pw"
        label="Password"
        :rules="[v => !!v || 'Password is required']"
        @keyup.enter="callLoginAction"
        required
        id="password"
      ></v-text-field>
      <v-btn
        class="submit-button"
        block
        @click="callLoginAction"
        :disabled="!valid"
        :loading="loading"
      >Log In</v-btn>
      <p v-if="loginErrMessage" class="error">Invalid username or password</p>
    </v-form>
  </main>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'LoginForm',
  props: [
    'loginErr',
    'loginErrMessage',
    'joinOrg',
    'redirect',
  ],
  data() {
    return {
      loading: false,
      valid: true,
      email: '',
      pw: '',

    };
  },
  methods: {
    async callLoginAction() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        await this.$store.dispatch('users/login', {
          email: this.$refs.email.value,
          password: this.$refs.password.value,
        });
        console.log(this.redirect);
        if (this.joinOrg) return;
        if (this.redirect) {
          this.$router.push(this.redirect);
        } else {
          this.$router.push('/');
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="css">
main {
  padding-top: 50px;
  .login-form {
    padding: 0px 40px;
    width: 33%;
    min-width: 450px;
    margin-bottom: 20px;
  }
  .logo {
    margin-bottom: 40px;
    padding: 0px 10px 0px;
    max-width: 100%;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .submit-button {
    background-color: rgb(23, 198, 140);
    color: white;
    &:disabled {
      background-color: gainsboro !important;
    }
  }
  .title {
    text-align: center;
  }
  .error {
    color: red;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// ../shared/components/LoginForm.vue